module.exports = __webpack_public_path__ + "img/slide-10.e1fe281e.jpeg";